import { observer } from 'mobx-react-lite'
import { useChatbotContext } from 'pages/chatbot/context'
import { ChatbotCollapse } from 'pages/chatbot/ui/ChatbotCollapse'
import { FirstMessage } from './FirstMessage'
import styles from './styles.module.scss'

export const StepFirstMessage = observer(() => {
  const { errors } = useChatbotContext()

  const isNestedError = errors.hasError('first_message')
  const firstMessageError = isNestedError ? 'Please complete all the fields' : null

  return (
    <ChatbotCollapse
      icon='messageSmile'
      title='Create your first message'
      tooltipProps={{
        label: 'Write the initial message a contact will receive from your AI Agent',
        placement: 'top',
        breakWord: true,
        maxWidth: 360,
      }}
      error={firstMessageError}
      isShowBottomBorder={false}
    >
      <div className={styles.container}>
        <FirstMessage />
      </div>
    </ChatbotCollapse>
  )
})
